import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface editingState {
  onEditPersonal: boolean
  onEditPersonalForm: boolean
  onEditCompany: boolean
  onEditCompanyForm: boolean
  onEditMembers: boolean
  onEditMembersForm: boolean
}

const initialState: editingState = {
  onEditPersonal: false,
  onEditPersonalForm: false,
  onEditCompany: false,
  onEditCompanyForm: false,
  onEditMembers: false,
  onEditMembersForm: false,
}

const editingSlice = createSlice({
  name: "editing",
  initialState,
  reducers: {
    setOnEditPersonal: (state, action: PayloadAction<boolean>) => {
      state.onEditPersonal = action.payload
    },
    setOnEditPersonalForm: (state, action: PayloadAction<boolean>) => {
      state.onEditPersonalForm = action.payload
    },
    setOnEditCompany: (state, action: PayloadAction<boolean>) => {
      state.onEditCompany = action.payload
    },
    setOnEditCompanyForm: (state, action: PayloadAction<boolean>) => {
      state.onEditCompanyForm = action.payload
    },
    setOnEditMembers: (state, action: PayloadAction<boolean>) => {
      state.onEditMembers = action.payload
    },
    setOnEditMembersForm: (state, action: PayloadAction<boolean>) => {
      state.onEditMembersForm = action.payload
    },
    resetEditModes: (state) => {
      state.onEditPersonal = false
      state.onEditPersonalForm = false
      state.onEditCompany = false
      state.onEditCompanyForm = false
      state.onEditMembers = false
      state.onEditMembersForm = false
    },
  },
})

export const {
  setOnEditPersonal,
  setOnEditPersonalForm,
  setOnEditCompany,
  setOnEditCompanyForm,
  setOnEditMembers,
  setOnEditMembersForm,
  resetEditModes,
} = editingSlice.actions

export default editingSlice.reducer
